import { render, staticRenderFns } from "./CooperationCard.vue?vue&type=template&id=29636c34"
import script from "./CooperationCard.vue?vue&type=script&lang=js"
export * from "./CooperationCard.vue?vue&type=script&lang=js"
import style0 from "./CooperationCard.vue?vue&type=style&index=0&id=29636c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports